import { REDIRECT} from '@/imports-files/pages/clients/jobs/job';
import { useTranslation } from 'react-i18next';


export const ACTION_OPTIONS = () =>  {
    const {t} = useTranslation(); 
    return{
                                'edit_job':{
                                                allowed_user: ['Administrator','client_admin', 'account_owner','client_user'],
                                                link: REDIRECT.client.jobs.edit,
                                                tab_name: ['active', 'draft'],
                                                title: t('datatable:actions:edit'),
                                                visble_in_all_jobs: false
                                            },
                                'duplicate_job':{
                                                    allowed_user: ['Administrator','client_admin', 'account_owner','client_user'],
                                                    link: REDIRECT.client.jobs.edit,
                                                    tab_name: ['active', 'archived'],
                                                    title: t('datatable:actions:duplicate'),
                                                    visble_in_all_jobs: true
                                                },
                                'promote':{
                                            allowed_user: ['Administrator','client_admin', 'account_owner','client_user'],
                                            link: REDIRECT.client.jobs.job_sharing,
                                            tab_name: ['active'],
                                            title: t('datatable:actions:promote'),
                                            visble_in_all_jobs: false
                                        },
                                'copy_job_url':{
                                                    allowed_user: ['Administrator','client_admin', 'account_owner','client_user', 'reviewer'],
                                                    title: t('datatable:actions:copy_job'),
                                                    link: `${REDIRECT.client.jobs.view_job}?q=desc`,
                                                    tab_name: ['active'],
                                                    visble_in_all_jobs: true
                                            },
                                'close_job':{
                                                allowed_user: ['Administrator','client_admin', 'account_owner','client_user'],
                                                title: t('datatable:actions:close_job'),
                                                tab_name: ['active'],
                                                visble_in_all_jobs: false
                                            },
                                'publish_job':{
                                                allowed_user: ['Administrator','client_admin', 'account_owner','client_user'],
                                                title: t('datatable:actions:publish'),
                                                tab_name: ['draft'],
                                                visble_in_all_jobs: false
                                            },
                                'delete_job':{
                                                allowed_user: ['Administrator','client_admin', 'account_owner','client_user'],
                                                title: t('datatable:actions:delete'),
                                                tab_name: ['draft'],
                                                visble_in_all_jobs: false
                                            }
      }  }


// ------------------------------- This will be removed -----------------------------
export const INITIAL_FILTER_VALUE = {
                                        'page'            : 1,
                                        'per_page'        : 10,
                                        'start_date'      : '',
                                        'end_date'        : '',
                                        'job_type'        : 'active',
                                        'search_text'     : '',
                                        'col_name'        : '',
                                        'order'           : '',
                                        'all_jobs'        : false                                      
                                    }

export const JOB_FILTER_LOCALSTORAGE_KEY = 'jobFiltersData';
// ------------------------------- This will be removed -----------------------------




// -------------------------------
export const DATA_TABLE_INITIAL_FILTER_VALUE = {

    'job_listing':  {
                        'start_date'      : '',
                        'end_date'        : '',
                        'location'        : '',
                        'job_type'        : 'active',
                        'search_text'     : '',
                        'col_name'        : '',
                        'order'           : '',
                        'all_jobs'        : false, 
                        'active'          : {
                                                'page'            : 1,
                                                'per_page'        : 10,
                                            },
                        'draft'           : {
                                                'page'            : 1,
                                                'per_page'        : 10,
                                            },
                        'archived'         : {
                                                'page'            : 1,
                                                'per_page'        : 10,
                                            }
                    },
    'candidate_listing':{
                            'date_choice'     : '',
                            'location'        : '',
                            'col_name'        : '',
                            'order'           : '',
                            'skill'           : '', 
                            'page'            : 1,
                            'per_page'        : 10,
                            'start_date'      : '',
                            'end_date'        : ''
                        }
}


export const DATA_TABLE_FILTER_LOCALSTORAGE_KEY = 'dataTableFiltersData';